import React from 'react';
import { Box, Stack } from '@mui/material';
import './styles.css';

interface ResourceShimmerCardProps {
	totalCards?: number;
	shouldScrollable?: boolean;
}

const ResourceShimmerCard = ({
	totalCards = 4,
	shouldScrollable = false
}: ResourceShimmerCardProps) =>
{
	return (
		<Box
			pb={1.5}
			sx={{
				display  : 'flex',
				position : 'relative',
				...(shouldScrollable
					? {
						overflowX              : 'auto',
						scrollbarGutter        : 'stable',
						'&::-webkit-scrollbar' : { display: 'none' },
						'-ms-overflow-style'   : 'none',
						'scrollbar-width'      : 'none',
						touchAction            : 'pan-x'
					}
					: {
						flexWrap : 'wrap'
					}),
				gap   : '8px',
				width : '100%'
			}}
			flexDirection={'row'}
		>
			{Array.from({ length: totalCards }).map((_, e) => (
				<Box
					key={e}
					sx={{
						flexShrink    : 0,
						bgcolor       : '#fff',
						borderRadius  : '13px',
						border        : '1px solid #D5D5D5',
						width         : 270,
						display       : 'flex',
						flexDirection : 'column',
						padding       : 'var(--pixel8)'
					}}
				>
					{/* Thumbnail */}
					<Box
						className='shimmerBG media'
						sx={{
							height       : '150px',
							borderRadius : '8px',
							marginBottom : 1
						}}
					/>

					{/* User Info */}
					<Stack direction='row' spacing={0.5} alignItems='center' pb={1}>
						{/* Profile Picture */}
						<Box
							className='shimmerBG'
							sx={{
								width        : '20px',
								height       : '20px',
								borderRadius : '50%'
							}}
						/>
						{/* Username */}
						<Box
							className='shimmerBG'
							sx={{
								width        : '100px',
								height       : '14px',
								borderRadius : '4px'
							}}
						/>
					</Stack>

					{/* Title */}
					<Box
						className='shimmerBG'
						sx={{
							width        : '80%',
							height       : '16px',
							borderRadius : '4px',
							marginBottom : 1
						}}
					/>

					{/* Description */}
					<Box
						className='shimmerBG'
						sx={{
							width        : '60%',
							height       : '14px',
							borderRadius : '4px'
						}}
					/>
				</Box>
			))}
		</Box>
	);
};

export default ResourceShimmerCard;
